import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import store, { RootState } from '../index';
import IntentionService from 'services/intention';
import { StatusCode } from 'libs/HTTP/constant';

interface DepartmentStore {
  list: any[];
}
const DefalutData: DepartmentStore = {
  // 意图列表
  list: []
};

const slice = createSlice({
  name: 'intention',
  initialState: DefalutData,
  reducers: {
    setIntentionList: (state, action: PayloadAction<any[]>) => {
      const { payload } = action;
      return { ...state, list: payload };
    }
  }
});
export const intentionStore = (state: RootState) => state.intention;
export const { setIntentionList } = slice.actions;
export default slice.reducer;

// 获取意图列表
export const getIntentionList = async (query: any = {}) => {
  let res: any = await IntentionService.getAllList(query);
  if (res.code === StatusCode.success) {
    let list = res.data || [];
    store.dispatch(setIntentionList(list));
  }
  return Promise.resolve(res);
};
